import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/components/shared/AnimatedCounter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/components/shared/Badge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/components/shared/DividerRow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/components/shared/GlassCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/components/shared/GradientText.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/components/shared/IconBadge.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/blockpage411/components/shared/icons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/components/shared/MobileBottomNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/components/shared/Pill.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/components/shared/ScrollReveal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/components/shared/SectionHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/blockpage411/components/shared/SectionHeading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","StaggerItem"] */ "/vercel/path0/blockpage411/components/shared/StaggerGroup.tsx");
